import { useCampaignsQuery } from "modules/campaigns/hooks/useCampaignsQuery"
import { Pagination } from "modules/shared/components/Pagination"
import { usePagination } from "modules/shared/hooks/usePagination"
import { useSortBy } from "modules/shared/hooks/useSortBy"
import { Route as CampaignsListRoute } from "routes/_base/_auth/campaigns/list/route"
import { CampaignsActivity } from "./Activity"
import { CampaignsFilter } from "./CampaignsFilter"
import { CampaignsTable } from "./CampaignsTable"

const ITEMS_PER_PAGE = 25

export type CampaignsSortFields = "name" | "status" | "type" | "createdAt"

export function Campaigns() {
  const search = CampaignsListRoute.useSearch()

  const { page, totalPages, setPage, setCount, count } = usePagination({
    search,
    fullPath: CampaignsListRoute.fullPath,
    total: ITEMS_PER_PAGE,
  })

  const { onSort, sortBy, fields } = useSortBy<CampaignsSortFields[]>({
    search,
    fullPath: CampaignsListRoute.fullPath,
    fields: ["name", "status", "type", "createdAt"],
  })

  const { data: campaigns, isPending } = useCampaignsQuery({
    query: {
      query: search.query,
      page,
      total: ITEMS_PER_PAGE,
      sortBy: sortBy ?? { field: "name", order: "asc" },
      filterBy: {
        status: search.filterBy?.status,
        flow: search.filterBy?.flow,
        archived: search.filterBy?.archived,
      },
    },
    onSuccess: (data) => {
      setCount(data.pageInfo.count)
    },
  })

  return (
    <div className="flex flex-col gap-6 w-full h-full">
      <CampaignsActivity />
      <div className="flex flex-col gap-4">
        <CampaignsFilter />
        <div className="flex flex-col gap-4">
          <CampaignsTable
            campaigns={campaigns}
            isPending={isPending}
            fields={fields}
            onSort={onSort}
            search={search}
          />
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
            count={count}
          />
        </div>
      </div>
    </div>
  )
}
